<template>
  <page layout="tabbed">
    <page-header title="Page With Steps">
      <template slot="actions">
        <el-button
          v-if="!stepsCompleted && !finalStep"
          type="primary"
          @click="nextStep"
          :disabled="!canContinue"
        >
          {{ $t('Button_NextStep') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
        <el-button v-else :disabled="!stepsCompleted" type="primary">
          {{ $t('Button_Save') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </template>
    </page-header>

    <page-steps
      ref="stepper"
      @can-continue-updated="canContinueUpdated"
      @next-button-updated="updateNextButton"
      @final-step-updated="updateFinalStep"
      :steps="steps"
      :model="model"
    />

    <p style="margin-left: 20px">All steps completed: {{ stepsCompleted }}</p>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageSteps from '@/common/components/page/PageSteps'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'

export default {
  name: 'SteppedPage',

  components: {
    Page,
    PageHeader,
    PageSteps
  },

  data() {
    return {
      nextButton: {},
      finalStep: false,
      isAllowedToContinue: false,
      steps: [
        {
          name: 'first',
          title: 'Step 1',
          subtitle: 'Title Step 1',
          component: StepOne,
          completed: false
        },
        {
          name: 'second',
          title: 'Step 2',
          subtitle: 'Title Step 2',
          component: StepTwo,
          completed: false
        },
        {
          name: 'third',
          title: 'Step 3',
          subtitle: 'Title Step 3',
          component: StepThree,
          completed: false
        }
      ],
      model: {}
    }
  },

  methods: {
    nextStep() {
      this.$refs.stepper.nextStep()
    },

    updateNextButton(newValue) {
      Object.assign(this.nextButton, newValue)
    },

    updateFinalStep(newValue) {
      this.finalStep = newValue
    },

    canContinueUpdated(newValue) {
      this.isAllowedToContinue = newValue
    }
  },

  computed: {
    stepsCompleted() {
      return this.steps.every(element => element.completed === true)
    },

    isLastStep() {
      if (this.$refs.stepper) {
        return this.$refs.stepper.finalStep
      } else {
        return false
      }
    },

    canContinue() {
      if (this.isAllowedToContinue) {
        return true
      } else if (this.nextButton && this.$refs.stepper) {
        let currentIndex = this.$refs.stepper.currentStep.index
        // eslint-disable-next-line standard/computed-property-even-spacing
        let isItemAllowedToContinue = this.nextButton[
          this.steps[currentIndex].name
        ]
        let isItemCompleted = this.steps[currentIndex].completed
        if (isItemAllowedToContinue || isItemCompleted) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/tests/page/SteppedPage.vue